import { Link } from "react-router-dom";

/**
 * PropHR brand logo.
 *
 * variant:
 *   - "auto"   , picks the transparent (dark-ink) logo. Best on light backgrounds.
 *   - "dark"   , transparent asset with indigo+orange ink. Use on light bg.
 *   - "light"  , white version. Use on dark bg.
 *   - "wordmark" , CSS-only text wordmark (no image). Useful for inline titles.
 *
 * size:
 *   - height in pixels for the image variants. Default 28.
 */
export default function Logo({
  variant = "dark",
  size = 28,
  to = null,
  className = "",
  testid = "logo",
}) {
  const isImg = variant === "dark" || variant === "light" || variant === "auto";
  const src =
    variant === "light"
      ? "/brand/prophr-logo-white.webp"
      : "/brand/prophr-logo.webp";

  const inner = isImg ? (
    <img
      src={src}
      alt="PropHR"
      style={{
        height: size,
        width: "auto",
        maxWidth: "none",
        objectFit: "contain",
        display: "block",
        flexShrink: 0,
      }}
      className={"select-none " + className}
      draggable={false}
      data-testid={testid}
    />
  ) : (
    <span
      className={"inline-flex items-baseline font-display font-extrabold tracking-tight select-none " + className}
      style={{ fontSize: size, lineHeight: 1 }}
      data-testid={testid}
    >
      <span className="brand-word-prop">prop</span>
      <span className="brand-word-hr">HR</span>
    </span>
  );

  if (to) {
    return <Link to={to} aria-label="PropHR home">{inner}</Link>;
  }
  return inner;
}
